export const SET_STRATEGIES = "performance/SET_STRATEGIES";
export const SET_INVESTMENT = "performance/SET_INVESTMENT";
export const SET_LOGS = "performance/SET_LOGS";
export const SET_LOGS_LIST = "performance/SET_LOGS_LIST";
export const DESTROY_LOGS = "performance/DESTROY_LOGS";
export const SET_ORDERS = "performance/SET_ORDERS";
export const SET_ORDERS_INFO = "performance/SET_ORDERS_INFO";
export const SET_LIMIT_LOGS = "performance/SET_LIMIT_LOGS";
export const SET_DATE_RANGE = "performance/SET_DATE_RANGE";
export const SET_MSG_LOGS = "performance/SET_MSG_LOGS";
export const SET_MSG = "performance/SET_MSG";
